import { render } from "./ModalTerms.vue?vue&type=template&id=510dbba9&scoped=true"
import script from "./ModalTerms.vue?vue&type=script&lang=js"
export * from "./ModalTerms.vue?vue&type=script&lang=js"

import "./ModalTerms.vue?vue&type=style&index=0&id=510dbba9&scoped=true&lang=css"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510dbba9"]])

export default __exports__